/* eslint-disable no-undef,no-console */
import angular from 'angular';
import EnvSettings from '../../../../config/settings';

angular
    .module('TALENYA-FE')
    .constant('EnvSettings', EnvSettings);
